import { useEffect, useState } from 'react'

import dayjs from 'dayjs'

import { FormattedDate } from '@twisto/components/atoms/format'

const timerUpdateInterval = 1000
type Props = {
  date?: Date | string
  onCompleted: () => void
}
export const ResendCounter = ({ date, onCompleted }: Props) => {
  const [secondsRemaining, setSecondsRemaining] = useState(
    dayjs(date).diff(dayjs(), 'seconds')
  )

  useEffect(() => {
    setSecondsRemaining(Math.max(dayjs(date).diff(dayjs(), 'seconds'), 0))

    const interval = setInterval(() => {
      setSecondsRemaining(Math.max(dayjs(date).diff(dayjs(), 'seconds'), 0))
    }, timerUpdateInterval)

    return () => {
      clearInterval(interval)
    }
  }, [date])

  useEffect(() => {
    if (secondsRemaining <= 0) {
      onCompleted()
    }
  }, [secondsRemaining, onCompleted])

  const timer = dayjs().startOf('day').add(secondsRemaining, 'seconds').toDate()

  return <FormattedDate date={timer} minute="2-digit" second="2-digit" />
}
